import type {Repository} from '@github-ui/current-repository'
import {hpcAttrs} from '@github-ui/hpc'
import {noop} from '@github-ui/noop'
import {useRef} from 'react'

import {useCommitPayload} from '../../contexts/CommitPayloadContext'
import {useCommitsLayoutPayload} from '../../hooks/use-commits-layout-payload'
import type {DiffEntryDataWithExtraInfo, HeaderInfo} from '../../types/commit-types'
import {VirtualizedBanner} from './banners/VirtualizedBanner'
import {Diff} from './Diff'
import {DiffsHeader} from './DiffsHeader'

interface DiffsProps {
  diffEntryData: DiffEntryDataWithExtraInfo[]
  contextLinePathURL: string
  unselectedFileExtensions?: Set<string>
  repo: Repository
  oid: string
  treeToggleElement: React.ReactElement
  headerInfo: HeaderInfo
  totalFileCount: number
}
export const virtualizationFileLimit = 40
const diffLimit = 10

export function SSRDiffs({
  diffEntryData,
  contextLinePathURL,
  repo,
  oid,
  treeToggleElement,
  headerInfo,
  totalFileCount,
}: DiffsProps) {
  const diffEntriesToUse = useRef(diffEntryData)
  const layoutPayload = useCommitsLayoutPayload()
  const shouldShowFlash = totalFileCount > virtualizationFileLimit
  const commitPayload = useCommitPayload()

  return (
    <div {...hpcAttrs()}>
      {shouldShowFlash && <VirtualizedBanner />}
      <DiffsHeader treeToggleElement={treeToggleElement} headerInfo={headerInfo} />
      {diffEntryData.map((currentDiffData, index) => {
        //we don't want to render more than 5 or 10 diffs
        if (diffLimit && index >= diffLimit) return null
        return (
          <div key={currentDiffData.pathDigest} className={index === 0 ? 'pt-0' : 'tmp-pt-3'}>
            <Diff
              onOptionCollapseToggle={noop}
              diffEntryData={diffEntriesToUse}
              index={index}
              helpUrl={layoutPayload.helpUrl}
              contextLinePathURL={contextLinePathURL}
              recalcTotalHeightOfVirtualWindow={noop}
              repo={repo}
              ignoreWhitespace={commitPayload.ignoreWhitespace}
              oid={oid}
            />
          </div>
        )
      })}
    </div>
  )
}
